(function () {
    let service = angular.module('chrisjsherm.service.uuid', []);

    service.factory('UuidService', UuidService);

    function UuidService() {

        /**
         * Generates a rfc4122 UUID based on:
         * http://stackoverflow.com/a/21963136/1579559.
         */
        const lut = Array.apply(null, { length: 256 }).map(
            function (_, i) {
                return (i < 16 ? '0' : '') + (i).toString(16);
            }
        );

        var formatUuid = function (object) {
            return lut[object.d0 & 0xff] + lut[object.d0 >> 8 & 0xff] + lut[object.d0 >> 16 & 0xff] + lut[object.d0 >> 24 & 0xff] + '-' +
                lut[object.d1 & 0xff] + lut[object.d1 >> 8 & 0xff] + '-' +
                lut[object.d1 >> 16 & 0x0f | 0x40] + lut[object.d1 >> 24 & 0xff] + '-' +
                lut[object.d2 & 0x3f | 0x80] + lut[object.d2 >> 8 & 0xff] + '-' +
                lut[object.d2 >> 16 & 0xff] + lut[object.d2 >> 24 & 0xff] +
                lut[object.d3 & 0xff] + lut[object.d3 >> 8 & 0xff] +
                lut[object.d3 >> 16 & 0xff] + lut[object.d3 >> 24 & 0xff];
        };

        const getRandomValuesFunc = window.crypto && window.crypto.getRandomValues ?
            function() {
                const dvals = new Uint32Array(4);
                window.crypto.getRandomValues(dvals);
                return {
                    d0: dvals[0],
                    d1: dvals[1],
                    d2: dvals[2],
                    d3: dvals[3]
                };
            } :
            function () {
                return {
                    d0: Math.random() * 0x100000000 >>> 0,
                    d1: Math.random() * 0x100000000 >>> 0,
                    d2: Math.random() * 0x100000000 >>> 0,
                    d3: Math.random() * 0x100000000 >>> 0
                };
            };

        const uuid = function () {
            return formatUuid(getRandomValuesFunc());
        };

        var service = {
            generate: generateUuid
        };

        return service;

        function generateUuid() {
            return uuid();
        }
    }
})();
(function () {
    myApp.factory('WebWorkerService', WebWorkerService);

    function WebWorkerService($rootScope, UuidService, GetIp) {

        function WorkerFunction() {
            let self = this;

            self.addEventListener('message', receiveMessage, false);

            function receiveMessage(message) {
                var data = JSON.parse(message.data),
                    workerResult;
                const messageId = data[1];

                switch (data[2]) {
                    case 'Close':
                        self.close();
                        break;
                    case 'AssociateChildsToMainElement':
                        workerResult = AssociateChildsToMainElement(data[0], data[3], data[4][0], data[4][1], data[4][2]);
                        break;
                    case 'LoadServerData':
                        workerResult = LoadServerData(data[0], data[3], data[4][0], data[4][1]);
                        break;
                }

                self.postMessage(JSON.stringify(
                    [
                        messageId,
                        workerResult
                    ]
                ));
            }

            function GetChildListsToAssociate(apiUrl, token, controller, action) {
                var xhr;
                var result;
                var method = "ListEnablesBasic";

                if (typeof action !== "undefined") {
                    method = action;
                }

                try {
                    xhr = new XMLHttpRequest();
                    xhr.open('Get', apiUrl + '/api/' + controller + '/' + method, false);
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.setRequestHeader('Authorization', token);
                    xhr.onreadystatechange = function () {
                        if ((xhr.readyState === 4) && (xhr.status === 200)) {
                            result = JSON.parse(xhr.responseText);
                        }
                    };
                    xhr.send();
                    return result;
                } catch (e) {
                    result = e.message;
                }
            }

            if (!String.prototype.endsWith) {
                String.prototype.endsWith = function (search, this_len) {
                    if ((typeof this_len === "undefined") || (this_len > this.length)) {
                        this_len = this.length;
                    }
                    return this.substring(this_len - search.length, this_len) === search;
                };
            }

            function GetNotNullChildsFromObject(object, mainElementId) {
                var childs = [];

                for (property in object) {
                    var propertyValue = object[property];

                    if (property.endsWith("Id") && (property !== mainElementId) && object.hasOwnProperty(property) && (typeof propertyValue !== "undefined") && (propertyValue !== null)) {
                        childs.push(property.slice(0, -2));
                    }
                }

                return childs;
            }

            Array.prototype.unique = function () {
                var a = this.concat();

                for (var i = 0; i < a.length; ++i) {
                    for (var j = i + 1; j < a.length; ++j) {
                        if (a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }

                return a;
            };

            function CompareChildsAndReturnDiferences(previousChildList, actualChildList) {
                var notFoundControllers = [];

                for (var i = 0; i < actualChildList.length; i++) {
                    var child = actualChildList[i];

                    if (previousChildList.indexOf(child) === -1) {
                        notFoundControllers.push(child);
                    }
                }

                var result = [notFoundControllers, previousChildList.concat(actualChildList).unique()];

                return result;
            }

            function AssociateChildsToMainElement(apiUrl, token, mainElementId, controller, action) {
                var oldChildsToGet = [];
                var newChildsToGet = [];
                var resultDiferences;
                var childList = [];
                mainElement = GetChildListsToAssociate(apiUrl, token, controller, action);

                for (var m = 0; m < mainElement.length; m++) {
                    var element = mainElement[m];

                    newChildsToGet = GetNotNullChildsFromObject(element, mainElementId);
                    resultDiferences = CompareChildsAndReturnDiferences(oldChildsToGet, newChildsToGet);
                    oldChildsToGet = resultDiferences[1];

                    if (resultDiferences[0].length) {
                        for (var r = 0; r < resultDiferences[0].length; r++) {
                            childList.push({
                                Child: resultDiferences[0][r] + "Id", Values: GetChildListsToAssociate(apiUrl, token, resultDiferences[0][r])
                            });
                        }
                    }

                    for (var c = 0; c < childList.length; c++) {
                        var child = childList[c];

                        for (property in element) {
                            var propertyValue = element[property];

                            if (property.endsWith("Id") && (property !== mainElementId) && element.hasOwnProperty(property) && (property === child.Child) && (typeof propertyValue !== "undefined") && (propertyValue !== null)) {
                                for (var v = 0; v < child.Values.length; v++) {
                                    var childValue = child.Values[v];

                                    if (childValue.Id === propertyValue) {
                                        element[property.slice(0, -2)] = {};
                                        element[property.slice(0, -2)][property] = childValue.Id;
                                        element[property.slice(0, -2)]["Description"] = childValue.Description;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                return mainElement;
            }

            function LoadServerData(apiUrl, token, controller, action) {
                return GetChildListsToAssociate(apiUrl, token, controller, action);
            }
        }

        var dataObj = '(' + WorkerFunction + ')();';
        var blob = new Blob([dataObj.replace('"use strict";', '')]);
        var blobURL = (window.URL ? URL : webkitURL).createObjectURL(blob, {
            type: 'application/javascript; charset=utf-8'
        });
        var webWorker;

        var serviceInterface = {
            CreateNewWorker: CreateNewWorker,
            InitiatePageWorker: InitiatePageWorker
        };

        function activate() {
            webWorker.addEventListener(
                'message',
                onWebWorkerResponse,
                false
            );
        }

        function InitiatePageWorker(webWorkerConfiguration) {
            const messageId = UuidService.generate();
            webWorker.postMessage(
                JSON.stringify([
                    GetIp(),
                    messageId,
                    webWorkerConfiguration.WebWorkerFunction,
                    webWorkerConfiguration.Token,
                    webWorkerConfiguration.Parameters
                ])
            );

            return messageId;
        }

        function CreateNewWorker() {
            webWorker = new Worker(blobURL);

            activate();
        }

        function onWebWorkerResponse(message) {
            var data = JSON.parse(message.data),
                messageId = data[0],
                result = data[1];

            $rootScope.$apply($rootScope.$broadcast(
                messageId,
                result
            ));

            webWorker.postMessage(JSON.stringify([
                GetIp(),
                messageId,
                'Close'
            ]));
        }

        return serviceInterface;
    }
})();